import React, { useRef, useEffect } from "react";
import "../css/shopkeeperinsurance.css";
import shopkeeperinsuranceimg from "../assets/shopkeeperinsuranceimg.webp";
import tollfreenumberimg from "../assets/tollfreenumberimg.webp";
import PoliciesSlider from "../components/PolicyiesSlider";
import ConsultationForm from "../components/ConsultationForm";
import ChatbotAi from "../components/ChatbotAi";
import axios from "axios";
import { Helmet } from 'react-helmet-async';

const ShopkeeperInsurance = () => {
    const API_URL = process.env.REACT_APP_Dashboard_API_URL;
    const imageRefs = useRef([]);
    const imageSources = [
        shopkeeperinsuranceimg,
        tollfreenumberimg
    ];

    useEffect(() => {
        if (imageRefs.current.length > 0) {
            let index = 0;
            const showNextImage = () => {
                imageRefs.current.forEach((img, i) => {
                    if (img) img.style.display = i === index ? "block" : "none";
                });
                index++;
                if (index >= imageRefs.current.length) index = 0;
                setTimeout(showNextImage, 3000);
            };
            showNextImage();
        }
    }, []);

    const handleSubmit = async (data) => {
        const inquriyData = new FormData();
        inquriyData.append("Name", data.Name);
        inquriyData.append("Email", data.Email);
        inquriyData.append("PreferredDate", data.Date);
        inquriyData.append("PreferredTime", data.Time);
        inquriyData.append("MobileNo", data.MobileNo);
        inquriyData.append("Status", "New");
        inquriyData.append("UserId", data.Id);
        inquriyData.append("InquiryType", "Insurance Inquiries");
        inquriyData.append("PolicyType", "Shopkeeper Insurance");
        inquriyData.append("IsLoggedIn", data.isLoggedIn);
        inquriyData.append("Otp", data.OTP);

        try {
            const response = await axios.post(`${API_URL}AddNewInquiries`, inquriyData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return { status: response.status, data: response.data };
        } catch (error) {
            return {
                status: 500,
                data: {
                    success: false,
                    message: error.response?.data?.message
                }
            };
        }
    };

    return (
        <div className="shopkeeperinsurance-container">
            <Helmet>
                <title>Shopkeeper Insurance Advice | Cover Your Store Today</title>
                <meta name="description" content="Protect your business with shopkeeper insurance advice tailored to small businesses. Get clear guidance on affordable coverage options." />
                <link rel="canonical" href="https://policysamjho.com/shopkeeper-insurance-advice/" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": "Shopkeeper Insurance Advice",
                        "description": "Tailored advice for shopkeeper insurance to protect your business. Compare coverage options and choose the right plan with Policy Samjho experts.",
                        "provider": {
                            "@type": "Organization",
                            "name": "Policy Samjho",
                            "url": "https://policysamjho.com/"
                        },
                        "serviceType": "Shopkeeper Insurance Consultation",
                        "areaServed": "IN",
                        "url": "https://policysamjho.com/shopkeeper-insurance-advice/",
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": "+91-9584484800",
                            "email": "info@policysamjho.com",
                            "contactType": "customer service"
                        }
                    })}
                </script>
            </Helmet>

            <div className="shopkeeperinsurance-hero-container">
                <div className="shopkeeperinsurance-hero-text-box">
                    <h1>
                        <span style={{ color: '#192437' }}>Shopkeeper </span>
                        <span style={{ color: '#F5A526' }}>Insurance Advice</span>
                    </h1>
                    <p style={{ color: "black", fontWeight: "600", fontSize: "18px", textAlign: 'justify' }}>
                        Secure your shop against unforeseen events like fire, theft, and natural disasters, ensuring your business's continuity and financial stability.
                    </p>
                </div>
                <div className="shopkeeperinsurance-imgslider">
                    {imageSources.map((image, index) => (
                        <img
                            key={index}
                            ref={(el) => (imageRefs.current[index] = el)}
                            src={image}
                            className="shopkeeperinsurance-sliderimg"
                            alt={`shopkeeperinsurance-slide-${index}`}
                            style={{ display: index === 0 ? "block" : "none" }}
                        />
                    ))}
                </div>
            </div>

            <div className="shopkeeperinsurance-containform-container">
                <div className="col-md-6 shopkeeperinsurance-info">
                    <h2 className="shopkeeperinsurance-heading">
                        <span style={{ color: '#192437' }}>What is </span>
                        <span style={{ color: '#F5A526' }}>Shopkeeper Insurance?</span>
                    </h2>
                    <p className="shopkeeperinsurance-text">
                        Shopkeeper insurance is a comprehensive policy that offers financial protection for your business premises and its contents against a variety of risks.
                    </p>

                    <h2 className="shopkeeperinsurance-subheading">
                        <span style={{ color: '#192437' }}>Comprehensive Coverage & </span>
                        <span style={{ color: '#F5A526' }}>Insurance Benefits</span>
                    </h2>
                    <ul className="shopkeeperinsurance-benefits">
                        <li>Public liability coverage</li>
                        <li>Coverage for burglary and theft</li>
                        <li>Protection from fire and allied perils</li>
                        <li>Financial assistance for loss of stock and cash</li>
                    </ul>

                    <p className="shopkeeperinsurance-text spaced-text">
                        Shopkeeper insurance is essential for business owners to safeguard their assets. This policy covers damage to the building, stock, and equipment, and also offers protection against liability claims, helping you manage unexpected expenses and continue operations without significant financial loss.
                    </p>
                </div>

                <div>
                    <h4 className="consultationform-heading">
                        <span style={{ color: "#192437" }}>Get a Free </span>
                        <span style={{ color: "#F5A526" }}> Shopkeeper Insurance Quote </span>
                    </h4>
                    <ConsultationForm onSubmit={handleSubmit} />
                </div>
            </div>

            <PoliciesSlider category="Shopkeeper Insurance" />
            <ChatbotAi />
        </div>
    );
};

export default ShopkeeperInsurance;